var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49992 1.58301C5.12992 1.58301 1.58325 5.12967 1.58325 9.49967C1.58325 13.8697 5.12992 17.4163 9.49992 17.4163C13.8699 17.4163 17.4166 13.8697 17.4166 9.49967C17.4166 5.12967 13.8699 1.58301 9.49992 1.58301ZM9.49992 15.833C6.00867 15.833 3.16659 12.9909 3.16659 9.49967C3.16659 6.00842 6.00867 3.16634 9.49992 3.16634C12.9912 3.16634 15.8333 6.00842 15.8333 9.49967C15.8333 12.9909 12.9912 15.833 9.49992 15.833ZM13.1337 6.00051L7.91658 11.2176L5.86617 9.17509L4.74992 10.2913L7.91658 13.458L14.2499 7.12467L13.1337 6.00051Z",
    fill: "#408F8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/tickIcon.23c83487fc3bbf337ddbc48ece7b6bf2.svg";
export { ForwardRef as ReactComponent };